var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipStudioIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,4h-24c-4.962,0 -9,4.037 -9,9v24c0,4.963 4.038,9 9,9h24c4.962,0 9,-4.037 9,-9v-24c0,-4.963 -4.038,-9 -9,-9zM34.772,29.527c-0.95,0.745 -1.795,1.109 -2.082,1.218l-5.35,2.204c-0.064,0.027 -0.091,0.105 -0.055,0.168l0.75,1.15c0.268,0.427 0.373,0.832 0.373,1.309c0,1.736 -1.523,2.15 -2.313,2.15c-1.305,0 -1.827,-0.891 -2.259,-1.577l-2.786,-4.4c-0.295,-0.468 -0.095,-1.086 0.414,-1.295l9.577,-3.941c0.609,-0.241 2.595,-1.268 2.595,-4.354c0,-2.613 -2.273,-5.568 -6.136,-5.568c-1.477,0 -3.409,0.795 -3.409,0.795l-5.954,2.441c-1.773,0.732 -1.773,1.404 -1.773,1.764c0,0.018 0.086,1.591 2.045,1.591c0.2,0 0.805,-0.091 1.636,-0.432l5.909,-2.445c1.227,-0.505 3.136,0.15 3.136,2.023c0,1.027 -0.595,1.395 -1.495,1.763l-3.677,1.518l-2.145,0.886c-1.214,0.5 -2.636,0.777 -3.591,0.777c-3.863,0 -6.363,-2.663 -6.363,-5.681c0,-1.859 0.795,-4.404 4.591,-5.963c0,0 0,0 2.059,-0.845c0.859,-0.359 2.077,-0.859 3.804,-1.573c0.559,-0.232 1.123,-0.464 1.859,-0.641c0.745,-0.177 1.659,-0.295 2.913,-0.295c7.272,0 11.136,5.454 11.136,9.886c0,3.863 -1.841,6.131 -3.409,7.367z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipStudioIcon);
export default __webpack_public_path__ + "static/media/clip-studio-icon.28003e33ddac1b98ec76f8cf22f93aa8.svg";
export { ForwardRef as ReactComponent };